/**
 * @generated SignedSource<<ac31ae6e67a223985c40f7547317f064>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoleBulkUpdateInput = {
  roles: ReadonlyArray<RoleInput>;
};
export type RoleInput = {
  charge_out_rate: number;
  default_hour_cost: number;
  id: number;
  name: string;
};
export type RoleBulkUpdateMutation$variables = {
  input: RoleBulkUpdateInput;
};
export type RoleBulkUpdateMutation$data = {
  readonly bulkUpdateRole: {
    readonly account: {
      readonly rate_cards: ReadonlyArray<{
        readonly id: number;
        readonly name: string | null | undefined;
        readonly role_charge_out_rates: ReadonlyArray<{
          readonly charge_out_rate: number | null | undefined;
          readonly rate_card_id: number;
          readonly role_id: number;
        }>;
      }>;
      readonly rate_type: string;
      readonly roles: ReadonlyArray<{
        readonly active: boolean;
        readonly default_hour_cost: number | null | undefined;
        readonly id: number;
        readonly name: string;
      }>;
    } | null | undefined;
  };
};
export type RoleBulkUpdateMutation = {
  response: RoleBulkUpdateMutation$data;
  variables: RoleBulkUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RoleBulkUpdateResult",
    "kind": "LinkedField",
    "name": "bulkUpdateRole",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "accounts",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rate_type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "where",
                "value": {
                  "name": {
                    "_eq": "Standard"
                  }
                }
              }
            ],
            "concreteType": "rate_cards",
            "kind": "LinkedField",
            "name": "rate_cards",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "role_charge_out_rates",
                "kind": "LinkedField",
                "name": "role_charge_out_rates",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "role_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rate_card_id",
                    "storageKey": null
                  },
                  {
                    "alias": "charge_out_rate",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "charge_out_rate_private",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "rate_cards(where:{\"name\":{\"_eq\":\"Standard\"}})"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "roles",
            "kind": "LinkedField",
            "name": "roles",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "active",
                "storageKey": null
              },
              {
                "alias": "default_hour_cost",
                "args": null,
                "kind": "ScalarField",
                "name": "default_hour_cost_private",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoleBulkUpdateMutation",
    "selections": (v3/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoleBulkUpdateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "ae13f4c9b07090895a1f5da6595355c8",
    "id": null,
    "metadata": {},
    "name": "RoleBulkUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation RoleBulkUpdateMutation(\n  $input: RoleBulkUpdateInput!\n) {\n  bulkUpdateRole(input: $input) {\n    account {\n      rate_type\n      rate_cards(where: {name: {_eq: \"Standard\"}}) {\n        id\n        name\n        role_charge_out_rates {\n          role_id\n          rate_card_id\n          charge_out_rate: charge_out_rate_private\n        }\n      }\n      roles {\n        id\n        name\n        active\n        default_hour_cost: default_hour_cost_private\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f229004de268cc5671c211b22b707011";

export default node;
